import PrimaryButton from "components/buttons/primary-button";
import TextDropdown from "components/inputs/text-dropdown";
import Typography from "components/typography";
import React, { useEffect, useMemo, useState } from "react";
import api from "services/axiosInstance";
import { GetActiveArtist } from "services/user/getUser";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { SongWithUrls, SplitSheet } from "types/response-type";
import Toast from "components/toast";

interface IProps {
  setSplit: (split: SplitSheet) => void;
  setTrackName: (name: string) => void;
  setTrackId: (id: string) => void;
}
const Default = ({ setSplit, setTrackName, setTrackId }: IProps) => {
  const [trackTitle, setTrackTitle] = useState("");

  const [trackTitles, setTrackTitles] = useState<string[]>([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [songs, setSongs] = useState<SongWithUrls[]>([]);
  const artist = GetActiveArtist();

  const EnterDisabled = useMemo(() => {
    if (trackTitle === "") {
      return true;
    }
    return false;
  }, [trackTitle]);

  const GetDiscography = async () => {
    setDataLoading(true);
    try {
      const { data } = await api.get(`/songs/artist/${artist?.id}`);

      if (!data.data) {
        return;
      }

      const songs: SongWithUrls[] = data.data;

      if (!songs || songs.length === 0) {
        Toast({ error: "No songs found" });
        return;
      }

      setSongs(songs);
      let trackNames: string[] = [];
      for (let i = 0; i < songs?.length; i++) {
        trackNames.push(songs[i].title);
      }
      setTrackTitles([...trackNames]);
    } catch (error) {
      Toast({ error });
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    GetDiscography();
  }, []);
  return (
    <Main>
      <Typography size="4xl" weight="bold">
        Splits
      </Typography>
      <Body>
        <Typography
          weight="semibold"
          size="3.6rem"
          m_size="2.6rem"
          mb="1.6"
          align="center"
        >
          Easily Split Royalties with Collaborators
        </Typography>
        <Typography
          size="xl"
          m_size="1.6rem"
          mb="3.2"
          align="center"
          color={Colors.grey500}
        >
          No more spreadsheets or confusion, Rated Afrika makes it simple to
          <span style={{ color: Colors.grey100 }}> split earnings </span>{" "}
          between
          <span style={{ color: Colors.grey100 }}>
            {" "}
            artists, producers, and songwriters.
          </span>{" "}
          Set percentages, invite collaborators, and we handle the rest
          automatically.
        </Typography>
        <DropContainer>
          <DropdownContainer>
            <TextDropdown
              placeholder="Select a release"
              items={trackTitles}
              selectItem={(title) => {
                setTrackTitle(title);
              }}
              chosenItem={trackTitle}
              value={trackTitle}
              dataLoading={dataLoading}
              disabled={songs.length === 0}
            />
          </DropdownContainer>
          <PrimaryButton
            text="Enter"
            fitContent
            sparkle
            inset
            disabled={EnterDisabled}
            onClick={() => {
              const song = songs.find((song) => song.title === trackTitle);

              setTrackName(song?.title || "");
              setTrackId(song?.id || "");
              if (song?.currentSplitSheet) {
                setSplit(song.currentSplitSheet);
              }
            }}
          />
        </DropContainer>
      </Body>
    </Main>
  );
};

export default Default;

const Main = styled.div`
  height: 100%;
  width: 100%;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  gap: 1.6rem;
  width: 68rem;
  min-height: 70vh;
  @media only screen and (max-width: 769px) {
    width: 100%;
    padding: 0 1.6rem;
    height: 100%;
  }
`;

const DropContainer = styled.div`
  display: flex;
  gap: 1rem;
  height: 4rem;
`;
const DropdownContainer = styled.div`
  width: 36rem;
`;
